(() => {
  const rootSelector = '[data-sticky-foundation-bundle]';
  const ctaSelector = '.product-form__submit, .custom-bundle-btn, .nw-new-bundle-cta-button, .labor-cta__button';
  const duplicateCtaAncestor = '.main-image-bottom-reviews-parent-checkout-button';

  const findTarget = () => {
    const productInfo = document.querySelector('[id^="ProductInfo-"]');
    if (!productInfo) return null;

    const buttons = Array.from(productInfo.querySelectorAll(ctaSelector)).filter(
      (button) => !button.closest(duplicateCtaAncestor),
    );

    return buttons.pop() || productInfo;
  };

  const initialize = (root) => {
    if (root.dataset.stickyFoundationBundleInitialized === 'true') return;

    const target = findTarget();
    if (!target) return;

    root.dataset.stickyFoundationBundleInitialized = 'true';
    const button = root.querySelector('[data-sticky-foundation-bundle-button]');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (button) {
      button.addEventListener('click', () => {
        target.scrollIntoView({
          behavior: reduceMotion ? 'auto' : 'smooth',
          block: target.matches(ctaSelector) ? 'center' : 'start',
        });
      });
    }

    new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const isVisible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        root.classList.toggle('is-visible', isVisible);
        root.inert = !isVisible;
      });
    }).observe(target);
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll(rootSelector).forEach(initialize);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
